import { render } from "./headbar.vue?vue&type=template&id=5b770c77&ts=true"
import script from "./headbar.ts?vue&type=script&lang=ts"
export * from "./headbar.ts?vue&type=script&lang=ts"
/* custom blocks */
import block0 from "./headbar.scss?vue&type=custom&index=0&blockType=styles&issuerPath=%2Fbuilds%2Felichens-avolta-connect%2Fsoftware%2Favolta-dashboard%2Fassets%2Fjs%2Fcomponents%2Fheadbar%2Fheadbar.vue&lang=scss"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/builds/elichens-avolta-connect/software/avolta-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__